import React from 'react';

const CommunityLibraryIcon = ({
  width = 18,
  height = 18,
  color = '#1E1E22',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.68754 8.90881V11.7421C3.68754 12.3301 4.16212 12.8046 4.75004 12.8046C5.33796 12.8046 5.81254 12.3301 5.81254 11.7421V8.90881C5.81254 8.32089 5.33796 7.84631 4.75004 7.84631C4.16212 7.84631 3.68754 8.32089 3.68754 8.90881ZM7.93754 8.90881V11.7421C7.93754 12.3301 8.41212 12.8046 9.00004 12.8046C9.58796 12.8046 10.0625 12.3301 10.0625 11.7421V8.90881C10.0625 8.32089 9.58796 7.84631 9.00004 7.84631C8.41212 7.84631 7.93754 8.32089 7.93754 8.90881ZM3.33337 16.3463H14.6667C15.2546 16.3463 15.7292 15.8717 15.7292 15.2838C15.7292 14.6959 15.2546 14.2213 14.6667 14.2213H3.33337C2.74546 14.2213 2.27087 14.6959 2.27087 15.2838C2.27087 15.8717 2.74546 16.3463 3.33337 16.3463ZM12.1875 8.90881V11.7421C12.1875 12.3301 12.6621 12.8046 13.25 12.8046C13.838 12.8046 14.3125 12.3301 14.3125 11.7421V8.90881C14.3125 8.32089 13.838 7.84631 13.25 7.84631C12.6621 7.84631 12.1875 8.32089 12.1875 8.90881ZM8.34129 1.81839L2.74546 4.76506C2.45504 4.91381 2.27087 5.21839 2.27087 5.54422C2.27087 6.03297 2.66754 6.42964 3.15629 6.42964H14.8509C15.3325 6.42964 15.7292 6.03297 15.7292 5.54422C15.7292 5.21839 15.545 4.91381 15.2546 4.76506L9.65879 1.81839C9.24796 1.59881 8.75212 1.59881 8.34129 1.81839Z"
      fill={color}
    />
  </svg>
);

export default CommunityLibraryIcon;
